import { faUsers } from '@fortawesome/pro-light-svg-icons/faUsers';
import { fetchStaffThunk } from 'actions/staff/StaffActions';
import Filter from 'components/Bookings2/List/Filter/Filter';
import { Staff } from 'model/Staff';
import { FunctionComponent, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';

interface StaffFilterProps {
    selected: Array<number>;
    className?: string;
    onChangeSelection?: (selectedStaffIds: Array<number>) => void;
}

export const StaffFilter: FunctionComponent<StaffFilterProps> = props => {
    const dispatch = useDispatch();

    const staff = useSelector<RootState, Array<Staff>>(state => state.staff.staff);

    useEffect(() => {
        dispatch(fetchStaffThunk());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const options = useMemo(
        () =>
            staff
                .filter(member => member.active)
                .map(member => ({
                    id: member.id ?? 0,
                    name: `${member.person.firstName} ${member.person.lastName}`.trim()
                })),
        [staff]
    );

    return (
        <Filter
            allLabel="All Staff"
            quantityLabel="staff"
            icon={faUsers}
            options={options}
            selectedOptions={options.filter(option => props.selected.includes(option.id))}
            onChangeSelection={selected => props.onChangeSelection?.(selected.map(option => option.id))}
            className={props.className}
        />
    );
};

export default StaffFilter;
